import React from "react";
import {
  Avatar,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  Image,
  Box,
  Text,
  useDisclosure,
} from "@chakra-ui/react";

// Avatar que, cuando tiene foto (src), permite ampliarla en un modal al hacer click.
// Si no hay src (avatar de iniciales), se comporta como un Avatar normal sin zoom.
// caption (opcional): { firstName, lastName, rut, course } se muestra bajo la imagen ampliada.
function ZoomableAvatar({ src, name, caption, stopPropagation = true, onClick, ...rest }) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleClick = (e) => {
    if (stopPropagation) e.stopPropagation();
    if (src) onOpen();
    if (onClick) onClick(e);
  };

  return (
    <>
      <Avatar
        src={src}
        name={name}
        onClick={handleClick}
        cursor={src ? "zoom-in" : rest.cursor}
        {...rest}
      />
      {src && (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
          <ModalOverlay bg="blackAlpha.700" onClick={(e) => e.stopPropagation()} />
          <ModalContent
            bg="transparent"
            boxShadow="none"
            maxW="fit-content"
            onClick={(e) => e.stopPropagation()}
          >
            <ModalCloseButton
              color="white"
              bg="blackAlpha.600"
              borderRadius="full"
              top="-10px"
              right="-10px"
              _hover={{ bg: "blackAlpha.800" }}
            />
            <ModalBody p={0}>
              <Image
                src={src}
                alt={name}
                borderRadius="12px"
                maxH="80vh"
                maxW="90vw"
                objectFit="contain"
                mx="auto"
              />
              {caption && (
                <Box mt={3} textAlign="center" color="white" px={2}>
                  {caption.firstName && (
                    <Text fontWeight="700" fontSize="lg" lineHeight="1.2">{caption.firstName}</Text>
                  )}
                  {caption.lastName && (
                    <Text fontWeight="700" fontSize="lg" lineHeight="1.2">{caption.lastName}</Text>
                  )}
                  {caption.rut && (
                    <Text fontSize="sm" fontWeight="500" opacity={0.85} mt={1}>RUT {caption.rut}</Text>
                  )}
                  {caption.course && (
                    <Text fontSize="sm" fontWeight="500" opacity={0.85}>{caption.course}</Text>
                  )}
                </Box>
              )}
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
    </>
  );
}

export default ZoomableAvatar;
